/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    keyboard: {
        type: "us",
        visible: false,
        callback: null,
    },
    device: {
        isMobile: false,
        areControllersConnected: false,
        inVRMode: false,
        canModify: true,
        cooperative: false,
        isLookControlsLocked: false,
    },
    isLoading: 0,
    notification: null,
    tourName: null,
    tours: [],
    ferrari: false,
    lastInvitedUsers: [],
    abort: {
        reason: "prova",
    }
};

const privateSlice = createSlice({
    name: "private",
    initialState: initialState,
    reducers: {
        setKeyboard: (state, action) => {
            Object.assign(state.keyboard, action.payload)
        },
        setTourName: (state, action) => {
            state.tourName = action.payload
        },
        setTours: (state, action) => {
            state.tours = action.payload
        },
        emptyKeyboardCallback: (state) => {
            state.keyboard.callback = null
        },
        setLoading: (state, action) => {
            const callback = action.payload.callback
            state.isLoading = callback(state.isLoading)
        },
        setIsMobile: (state, action) => {
            state.device.isMobile = action.payload
        },
        setAreControllersConnected: (state, action) => {
            state.device.areControllersConnected = action.payload
        },
        setCanModify: (state, action) => {
            state.device.canModify = action.payload
        },
        setCooperative: (state, action) => {
            state.device.cooperative = action.payload
        },
        setVRMode: (state, action) => {
            state.device.inVRMode = action.payload
        },
        setLockControl: (state, action) => {
            state.device.isLookControlsLocked = action.payload
        },
        setNotification: (state, action) => {
            state.notification = action.payload
        },
        setLastInvitedUsers: (state, action) => {
            state.lastInvitedUsers = action.payload
        },
        setReason: (state, action) => {
            state.abort.reason = action.payload
        },
        setFerrari: (state, action) => {
            state.ferrari = action.payload
        }
    }
});

export const {
    setKeyboard,
    setTourName,
    setReason,
    setTours,
    setLastInvitedUsers,
    setVRMode,
    setIsMobile,
    setCanModify, 
    setAreControllersConnected,
    setCooperative,
    setLoading,
    setLockControl,
    emptyKeyboardCallback,
    toggleSharingButtonText,
    setNotification,
    setFerrari
} = privateSlice.actions;

export default privateSlice;
